import { BOARD_DEFERRED_DATA_LOAD_SUCCESS } from '../../../actions/board/board-deferred-data';
import { SWIMLANE_JQL_SET_DATA } from '../../../actions/swimlane';
import { WORK_DATA_SET } from '../../../actions/work';
import type { Action } from '../../../types';

import type { JQLSwimlanesState } from './types';

const initialState: JQLSwimlanesState = { swimlanes: [] };

export function jqlSwimlanesReducer(
	// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
	state: JQLSwimlanesState | void | null = initialState,
	action: Action,
): JQLSwimlanesState {
	if (action.type === WORK_DATA_SET && action.payload.jqlSwimlanes) {
		const { jqlSwimlanes } = action.payload;
		return { swimlanes: jqlSwimlanes };
	}

	if (action.type === SWIMLANE_JQL_SET_DATA && action.payload != null) {
		return { swimlanes: action.payload };
	}

	if (action.type === BOARD_DEFERRED_DATA_LOAD_SUCCESS && action.payload.jqlSwimlanes) {
		const { jqlSwimlanes } = action.payload;
		return { swimlanes: jqlSwimlanes };
	}

	return state || initialState;
}
